import React, { useState, useEffect } from "react";
import { Modal, ModalBody } from "reactstrap";

const SmartpakModal = ({ clickedRow, showModal, toggleModal }) => {
  const closeBtn = (
    <div
      className="links_right"
      style={{ position: "absolute", top: "15px", right: "15px" }}
    >
      <button
        className="modal_close bg-transparent"
        onClick={toggleModal}
        type="button"
      >
        <img src="/images/cross.svg" />
      </button>
    </div>
  );

  return (
    <Modal
      isOpen={showModal}
      toggle={toggleModal}
      backdrop={true}
      keyboard={true}
      // centered={true}
      external={closeBtn}
      id="smartpak_modal"
    >
      <ModalBody
        style={{
          padding: 0,
          overflowY: "auto",
          overflowX: "hidden",
          height: "90vh",
        }}
      >
        <iframe
          title="SmartPak Dashboard"
          src="https://smartpak-five9-dashboard-eeene9c8cbeye5dx.centralus-01.azurewebsites.net/"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </ModalBody>
    </Modal>
  );
};
export default SmartpakModal;
